export default (satellite) => {
  const { id, orbitalPosition } = satellite;

  const getId = () => {
    return id;
  };

  const getOrbitalPosition = () => {
    return orbitalPosition;
  };

  const getNominalOrbitalPosition = () => {
    let positionAsInt = parseFloat(orbitalPosition);

    // For East, it's ok.
    // For west, take the negative value
    if (
      orbitalPosition &&
      orbitalPosition.toUpperCase() &&
      orbitalPosition.includes('W')
    ) {
      positionAsInt = -positionAsInt;
    }
    return positionAsInt;
  };

  return { getId, getOrbitalPosition, getNominalOrbitalPosition };
};
